<template>
<div>
    <!-- <div  style="width: 100%;background-color: rgb(34, 34, 34);height:54px;">
        <span data-v-3c6d3300="" style="margin-left: 20px; float: left;">
            <img data-v-3c6d3300="" src="../assets/img/MKD-logo.png" style="max-height: 50px;cursor:pointer;" @click="toOurWeb()">
           
        </span>
    </div> -->
       <!-- <div style="width:70%;margin:auto;font-size: 1.17em;">
            <p>Dear Customers,</p> 
            Due to a very high demand to access to our platform, 
            We are sorry to inform you that new requests to access to our service for customers with less than 30 orders per day are currently closed. 
            We are sorry for the inconvenience.
            We're currently creating a new system to allow sellers with less than 30 orders per day to use our service, 
            It should be ready in 2 or 3 months.
            <p>Thank you for your understanding</p>
            <P style="text-align:right;margin-right:170px;">SR Team</P> 
        </div> -->
    <div class="login-container register"> 
        <div class="login-logo-img"> <img src="../assets/img/MKD-logo2.jpg" alt="" @click="toOurWeb()"> </div>
        <el-form class="login-form" autoComplete="on" ref="loginForm" label-position="left">
            <div class="title-container">
                <h3 class="title">{{gets('$注册')}}</h3>
            </div>
        </el-form>
        <el-form ref="form" label-width="80px">
          <form-list :store="UserPage" class="cm-register" style="position:relative;" :entity="UserPage.Entity">
               <span style="position:absolute;bottom: 399px;font-size:14px;font-weight:700;color: #606266;" v-if="name==1"><span class="red">*</span> Wechat ID
               </span>
               <span style="position:absolute;bottom: 399px;font-size:14px;font-weight:700;color: #606266;" v-else-if="name==2"><span class="red">*</span> Skype ID
               </span>
               <span style="position:absolute;bottom: 399px;font-size:14px;font-weight:700;color: #606266;" v-else><span class="red">*</span> WhatsApp number
               </span>
            </form-list>
            <!-- <div class="email-notice" style="text-align:center;margin:30px 0px;font-weight:bold;color:red;">
                <p>Thank you for your registration!</p>
                <p style="line-height:20px;">You should receive an email shortly with a confirmation link to activate your account.</p>
            </div> -->
            <el-button type="primary" class="register-btn" size="large" @click="UserPageToUpdate()">{{gets('$注册')}}</el-button>
            <el-form-item  class="toLogin">
             <div  v-if="language=='CN'">已经有账号了？ <span style="color:#4680ff;cursor:pointer;" @click="Customerlogin">登录</span></div>
              <div v-else>Already have account？ <span style="color:#4680ff;cursor:pointer;" @click="Customerlogin">Sign in</span></div>
             </el-form-item>
        </el-form>
    </div>

    <!-- 邮件发送提示弹窗 -->
    <!-- <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false" 
        width="30%"
        :before-close="dialogVisible = false">
        
        <div style="font-size:14px;">
            <p>Thank you for your registration!</p>
            <p>You should receive an email shortly with a confirmation link to activate your account.</p>
            <p>If you don't receive this email within 5 minutes, please check your spam inbox.</p>
        </div>
        <span slot="footer" class="dialog-footer">
          
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog> -->

</div>

    
</template>

<script>
    import {
        IsRights,
        Modulel,
        Permission,
        Clone,
        ToComponentData,
        CheckByConfig,
        ToSubmitData
    } from '@/config/config'
    import gets from '@/model/language'
    import {
        InitUserPage
    } from '@/config/Sys/RegisterConfig.js'
    import {
        userRequest
    } from '@/request/user.js'
import {
    languageRequest
} from '../request/language'


    var UserStoreName;
    var UserConfig;
    var self;
    export default {
        data() {
            return {
                ModalName: gets('$新增客户'),
                IsResetPassword: false,
                newPassword: '',
                 Value: 'EN',
                 dialogVisible: false,//邮箱提示弹窗
            
            }
        },
        created() {
            


            this.Value = window.$.cookie('LanguagesTag')
            if(!this.Value)
            {
                    this.Value = 'EN';
                    this.LenChange()
            }

            this.init()



        },
        computed: {
             language() {
                return window.$.cookie('LanguagesTag')
            },
            
            UserPage() {
                return this.$store.state[UserStoreName];
            },
            name(){
                //console.log(this.$store.state['name'],12321312312)
                  return this.$store.state['name'].name;
            }
        },
        methods: {
            toOurWeb(){
                window.location.href="http://service.shipping-revolution.com/"
            },
            Customerlogin() {
                self.$router.push('/Customerlogin')
            },
            init() {
                window.rootVue.setThisWindowVueComponent(this);
                self = this;
                UserConfig = InitUserPage(window.rootVue.thisWindow.tag);
                UserStoreName = UserConfig.storeName;
                UserConfig.initPublicDataCurrencyID();
                UserConfig.initPageData();
                UserConfig.initRegionCountry();
                self.$set(self.UserPage, 'Entity', ToSubmitData(ToComponentData(self.UserPage.FieldData)))
            },

        LenChange() {
            window.$.cookie('LanguagesTag', this.Value)
            languageRequest.Change(function(d) {
                window.location.reload()
            }, this.Value)

        },
            UserPageToUpdate() {
             var reg =  /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
              if(!reg.test(self.UserPage.Entity.Email)){

               self.$message.error(self.gets("$邮箱格式不正确"))
                    return

              }

                if(self.UserPage.Entity.Password != self.UserPage.Entity.RPassword){
                    self.$message.error(self.gets("$密码不一致"))
                    return
                }
                
                if(self.name == "WeChat"){
                    self.UserPage.contactType=1
                }
                else if(self.name=="Skype"){
                    self.UserPage.contactType=2
                }else{
                    self.UserPage.contactType=3
                 }
                self.UserPage.Update(self.UserPage, function(d) {
                   
                    //self.$message.success(self.gets("$注册成功"))
                    self.$message({
                        duration: 20000,
                        message: 'Thank you for your registration! You should receive an email shortly with a confirmation link to activate your account.',
                        type: 'success'
                    }); 
                   
                    self.$router.push('/Customerlogin')
                   
                    
                })
            },
            gets: gets,
            g: gets,
        },
    }
</script>


<style>
    html {
        background-color: #F5F9FD;
        color: #666;
    }
    .login-container {
        
        margin: auto;
        margin-top: 150px;
        background: #FFFFFF;
        padding: 12px;
        border: 0 solid rgba(120, 130, 140, 0.13);
        border-radius: 5px;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    }
    .register{
        width: 530px;
        overflow: hidden;
        margin-bottom: 50px;
        margin-top: 100px !important;
    }
    .right {
        float: right;
    }
    .register-btn{
        width: 85%;
    margin-left: 10% !important;
    margin-bottom: 20px;
        /* float: right !important;
        margin-right: 140px !important; */
        /* margin-bottom: 30px !important; */
    }
    .cm-register{
        padding-right: 50px;
    }
    .cm-register .el-form-item .el-form-item__label{
        width: 150px !important;
    }
    .cm-register .el-form-item .el-form-item__content{
        margin-left: 150px !important;
    }
    .login-container .login-logo-img{
    padding-top: 30px;
    text-align: center;
    width: 100%;
    cursor: pointer;
}
.login-container .login-logo-img img{
    width: 270px;
}
.toLogin{
    
    text-align: center;
}
.toLogin .el-form-item__content{
margin-left: 0px !important;
margin-top: 20px;
line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// Register.vue?778cb9b6